import { Grid, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import zIndex from '@mui/material/styles/zIndex'
import i18n from 'i18n'
import { min } from 'lodash'

export const PopupSectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: '11px',
  lineHeight: '16px',
  fontWeight: 700,
  textTransform: 'uppercase',
  color: theme.palette.text.primary
}))

export const PopupSectionContent = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column'
}))

export const PopupSectionRow = styled(Grid)(({ color, theme }) => ({
  width: '100%',
  display: 'flex',
  flexWrap: 'nowrap',
  alignItems: 'center',

  fontSize: 14,
  color: theme.palette.text.primary,

  '& > div': {
    display: 'flex',
    alignItems: 'center'
  },

  '&[data-onlytitle="true"]': {
    '& > div': {
      width: '100%'
    },
    '& span[data-content="title"]': {
      width: '100%',
      fontWeight: 400
    }
  },

  '& span[data-content="icon"]': {
    height: 16,
    fontSize: '0.625rem',
    minWidth: '42px',
    fontWeight: 400,
    color: theme.palette.input.placeholder
  },
  '& span[data-content="icon-small"]': {
    height: 12,
    fontSize: '0.625rem',
    minWidth: '42px',
    fontWeight: 400,
    color: theme.palette.input.placeholder,
    margin: theme.spacing(0, 3, 0, 0)
  },
  '& span[data-content="icon-regular"]': {
    height: 20,
    fontSize: '0.625rem',
    width: 20,
    maxWidth: 20,
    fontWeight: 400,
    color: theme.palette.input.placeholder,
    margin: theme.spacing(
      0,
      i18n.dir() === 'ltr' ? 3 : 0,
      0,
      i18n.dir() === 'rtl' ? 3 : 0
    )
  },
  '& span[data-content="icon-big"]': {
    height: 24,
    fontSize: '0.625rem',
    width: 24,
    minWidth: '42px',
    fontWeight: 400,
    color: theme.palette.input.placeholder
  },
  '& span[data-content="action"]': {
    color: color
  },

  '&[data-hasactionbg="true"] span[data-content="action"]': {
    backgroundColor: 'transparent',
    transition: 'background-color 150ms ease'
  },

  '&[data-hasactionbg="true"] span[data-content="action"]:hover': {
    backgroundColor: theme.palette.background.paper
  }
}))

export const PopupSection = styled(Grid)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  color: 'rgb(129 129 129)'
}))
